import React, { FunctionComponent } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { body2 } from 'ui/theme';
import { createBandedDataPoints } from './utils/dataHelpers';

export type DistributionGraphProps = {
  max: number;
  min: number;
  xData: Array<number>;
  xMax: number;
  xMin: number;
  yData: Array<number>;
  yMax: number;
  yMin: number;
};

const createChartOptions = (
  xMin: number,
  xMax: number,
  xData: Array<number>,
  yMin: number,
  yMax: number,
  yData: Array<number>,
  currentMin: number,
  currentMax: number,
): Record<string, any> => {
  const seriesData = createBandedDataPoints(xData, yData, currentMin, currentMax);
  const mainChart = {
    chart: {
      animation: false,
      height: 300,
      width: 600,
      type: 'areaspline',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      min: xMin,
      max: xMax,
      title: {
        margin: -5,
        y: 7,
        style: {
          ...body2,
        },
        text: 'Percentile',
      },
      tickInterval: 20,
    },
    yAxis: {
      min: yMin,
      max: yMax,
      title: {
        margin: 5,
        x: -7,
        style: {
          ...body2,
        },
        text: 'Probability',
      },
    },
    plotOptions: {
      areaspline: {
        enableMouseTracking: false,
        showInLegend: false,
        marker: {
          enabled: false,
        },
      },
      series: {
        animation: false,
      },
    },
    series: seriesData,
    title: {
      text: undefined,
    },
  };
  return mainChart;
};

export const DistributionGraph: FunctionComponent<
  React.PropsWithChildren<DistributionGraphProps>
> = (props) => {
  const { max, min, xData, xMax, xMin, yData, yMax, yMin } = props;
  const mainChart = createChartOptions(xMin, xMax, xData, yMin, yMax, yData, min, max);
  return <HighchartsReact highcharts={Highcharts} constructorType={'chart'} options={mainChart} />;
};
